import { render, staticRenderFns } from "./Shade.vue?vue&type=template&id=2a64c344&scoped=true&"
import script from "./Shade.vue?vue&type=script&lang=js&"
export * from "./Shade.vue?vue&type=script&lang=js&"
import style0 from "./Shade.vue?vue&type=style&index=0&id=2a64c344&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.6@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a64c344",
  null
  
)

export default component.exports